/* eslint-disable no-unneeded-ternary */
/* eslint-disable indent */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Accordion } from 'semantic-ui-react';
import styled, { css } from 'react-emotion';
import { cssMediaMax } from '~/modules/core/utils/cssHelpers/cssMedia';
import withDirection from '~/modules/core/utils/mediaHelpers/withDirection';

import AccordionMainList from './FilterStyle';

const FilterWrapper = withDirection(styled.div`
  width: 20%;
  ${cssMediaMax.tablet`
    width: 100%;
    min-height: 76vh;
  `}
  .accordion.ui {
    ${cssMediaMax.tablet`
      padding: 0;
      border-right: none !important;
      border-left: none !important;
    `}
    .title {
      padding: ${props => props.theme.paddings.large}px 0;
      ${props => cssMediaMax.tablet`
        ${props.direction === 'rtl'
          ? css`
              text-align: right;
            `
          : css`
              text-align: left;
        `}
        padding-left: ${props.theme.paddings.medium}px;
        padding-right: ${props.theme.paddings.medium}px;
      `};
    }
    .content {
      ${props => cssMediaMax.tablet`
        padding-left: ${props.theme.paddings.medium}px !important;
        padding-right: ${props.theme.paddings.medium}px !important;
      `};
    }
  }
`);

const LoadingOverlayContainer = styled.div`
  position: relative;
  min-height: 300px;
`;
const LoadingOverlay = withDirection(styled.div`
  position: absolute;
  top: 0px;
  ${props => (props.direction === 'rtl'
    ? css`
        right: 0px;
      `
    : css`
        left: 0px;
  `)}
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.03);
`);

class FilteringAccordion extends Component {
  state = { activeIndex: !this.props.showFilterDropdown ? [0, 1, 2, 3] : 0 };

  handleTitleClick = (e, itemProps) => {
    const { index } = itemProps;
    const { activeIndex } = this.state;
    let newState;
    if (!this.props.showFilterDropdown) {
      if (activeIndex.indexOf(index) > -1) {
        newState = activeIndex.filter(i => i !== index);
      } else {
        newState = [...activeIndex, index];
      }
      this.setState({ activeIndex: newState });
    } else {
      this.setState({ activeIndex: index });
    }
  };

  accordion = props => (
    <Accordion
      panels={props.panels}
      exclusive={props.showFilterDropdown ? true : false}
      fluid
      activeIndex={this.state.activeIndex}
      onTitleClick={this.handleTitleClick}
    />
  );

  render = () => {
    const { isLoading } = this.props;
    return (
      <FilterWrapper>
        <AccordionMainList>
          {isLoading ? (
            <LoadingOverlayContainer>
              {this.accordion(this.props)}
              <LoadingOverlay />
            </LoadingOverlayContainer>
          ) : (
            this.accordion(this.props)
          )}
        </AccordionMainList>
      </FilterWrapper>
    );
  };
}

FilteringAccordion.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  showFilterDropdown: PropTypes.bool,
};
FilteringAccordion.defaultProps = {
  showFilterDropdown: false,
};
export default FilteringAccordion;
